import type { LineEdits } from "../types";
import type { MaterialLineItemOption } from "../types";
import type { MaterialRowItem } from "./materialLineItems";

export type SupplierComparisonCartItem = {
    id: string;
    manufacturerProductId: string;
    value: string;
    supplierName?: string;
};

function resolveProductName(
    productId: string,
    options: MaterialLineItemOption[],
    category: string,
): string {
    for (const option of options) {
        if (option.ProductId === productId) return option.ProductName;
        if (option.Variants?.some((variant) => variant.ProductId === productId)) {
            return option.ProductName;
        }
    }
    return category;
}

function addComparisonEntry(
    result: Record<string, SupplierComparisonCartItem>,
    editKey: string,
    category: string,
    options: MaterialLineItemOption[],
    materials: LineEdits,
    cartIds: Record<string, string>,
) {
    const edit = materials[editKey];
    const cartId = cartIds[editKey];
    if (!edit?.selectedProductId || !cartId || Number(edit.quantity) <= 0) {
        return;
    }

    result[editKey] = {
        id: cartId,
        manufacturerProductId: edit.selectedProductId,
        value: resolveProductName(edit.selectedProductId, options, category),
        supplierName: edit.supplierName || undefined,
    };
}

export function buildSupplierComparisonValues(
    materialsByGroup: Record<string, MaterialRowItem[]>,
    materials: LineEdits = {},
    cartIds: Record<string, string> = {},
): Record<string, SupplierComparisonCartItem> {
    const result: Record<string, SupplierComparisonCartItem> = {};

    for (const rows of Object.values(materialsByGroup)) {
        for (const row of rows) {
            if (row.mode === "single") {
                addComparisonEntry(
                    result,
                    row.id,
                    row.category,
                    row.availableProducts,
                    materials,
                    cartIds,
                );
                continue;
            }

            for (const line of row.lines) {
                addComparisonEntry(
                    result,
                    line.lineId,
                    row.category,
                    line.availableProducts,
                    materials,
                    cartIds,
                );
            }
        }
    }

    return result;
}
